export enum RegistrationStepName {
  LOCATIONS = 'Locations',
  COMPANY_INFORMATION = 'Company Information',
}
